const ALLOWED_SHAPES = [
  "Princess", "Emerald", "Pear", "Round", "Asscher", 
  "Heart", "Oval", "Cushion", "Marquise", "Radiant"
];

let gtmLoaded = false;

function getDiamondDataFromURL(){
  const path = window.location.pathname;
  
  // Makes the second number (decimal) optional
  const match = path.match(/(\d+)(?:-(\d+))?-carat-([a-z]+)/i);

  if(!match) return null;

  // If there's a second number, add it as a decimal. Otherwise, just use the first number.
  const carat = match[2] ? match[1] + "." + match[2] : match[1];
  
  // Force consistent capitalization
  const shape = match[3].charAt(0).toUpperCase() + match[3].slice(1).toLowerCase();

  return {carat, shape};
}

const addTryOnAnalytics = () => {
  // Check if GTM has already been injected to prevent the infinite loop
  if (gtmLoaded) return; 

  let scriptTag = document.createElement('script');

  let scriptContent = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-P9FG4SV');`;

  scriptTag.text = scriptContent;
  document.head.appendChild(scriptTag);

  let noScriptTag = document.createElement('noscript');
  noScriptTag.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P9FG4SV" height="0" width="0"></iframe>';
  document.body.append(noScriptTag);

  // Set flag to true so it never runs again on this page load
  gtmLoaded = true;
};

function initializeButtonVisibility() {
  const button = document.getElementById("camweara-diamond-button");
  if (!button) return;

  const diamond = getDiamondDataFromURL();
  
  if (diamond && ALLOWED_SHAPES.includes(diamond.shape)) {
    button.style.display = "flex"; 
    addTryOnAnalytics(); // This is now safe to be called by the 500ms interval
  } else {
    button.style.display = "none";
  }
}

// Check on initial load
window.addEventListener('DOMContentLoaded', initializeButtonVisibility);

// Check periodically for Shopify themes that load content dynamically without refreshing
setInterval(initializeButtonVisibility, 500);

function openCamwearaDiamond(){
  let iframe = document.getElementById("camweara-diamond-iframe");

  if(!iframe){
    iframe = document.createElement("iframe");
    iframe.id = "camweara-diamond-iframe";
    iframe.style.position="fixed";
    iframe.style.top="0";
    iframe.style.left="0";
    iframe.style.width="100%";
    iframe.style.height="100%";
    iframe.style.border="none";
    iframe.style.zIndex="2147483647";

    iframe.allow = "camera *; web-share; fullscreen *";
    iframe.setAttribute("allowfullscreen", "true");

    document.body.appendChild(iframe);
  }

  iframe.style.display = "block";

  const diamond = getDiamondDataFromURL();
  const carat = diamond?.carat;
  const shape = diamond?.shape;

  iframe.src = `https://cdn.camweara.com/camweara_diamond/?TY50687&company_name=rockher&carat=${carat}&dshape=${shape}`;
}

function closeCamwearaDiamond(){
  const iframe = document.getElementById("camweara-diamond-iframe");

  if(iframe){
    iframe.style.display="none"; 
    iframe.src="";
  }
}

window.addEventListener("message",(event)=>{
  if(event.data==="closeIframe" || event.data==="closeDiamondFinder"){
      closeCamwearaDiamond();
  }
});